module.exports = require("@apollo/client/link/error");